(function mt_bootMeetTheTeam_unstuck() {
  if (!window.gsap || !window.ScrollToPlugin) return;
  gsap.registerPlugin(ScrollToPlugin);

  const SECTIONS = Array.from(document.querySelectorAll('.section-meet-the-team'));
  if (!SECTIONS.length) return;

  const DURATION = 0.85;
  const COOL = 260;
  const TOUCH_SNAP = 28;
  const STICKY_TOP = 240;

  SECTIONS.forEach((section) => {
    if (section.dataset.mtInit === '1') return;
    section.dataset.mtInit = '1';

    const buttons = Array.from(section.querySelectorAll('.team-btn'));
    const panels = Array.from(section.querySelectorAll('.tabs__panels .tabs__panel'));
    const navWrap = section.querySelector('.tabs__nav');
    const navUl = section.querySelector('.tabs__nav ul');
    const panelsWrap = section.querySelector('.tabs__panels');
    if (!buttons.length || !panels.length || !navWrap || !navUl || !panelsWrap) return;

    const btnById = new Map(buttons.map(b => [b.dataset.scrollTarget?.replace('#',''), b]));
    const panelIndex = new Map(panels.map((p,i) => [p, i]));

    let scrolling = false;
    let lastIntent = 0;
    let hoverActive = false;
    let currentIndex = Math.max(0, panels.findIndex(p => p.classList.contains('active')));
    let wrapTop = 0, colH = 0, ulH = 0, maxOffset = 0;
    let tween = null;
    let safetyTimer = null;

    const setActiveBtn = (btn) => {
      buttons.forEach(b => {
        const a = b === btn;
        b.classList.toggle('active-mt', a);
        b.setAttribute('aria-selected', a ? 'true' : 'false');
      });
    };
    const initBtn = btnById.get(panels[currentIndex]?.id);
    if (initBtn) setActiveBtn(initBtn);

    const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
    const canStep = () => !scrolling && (performance.now() - lastIntent > COOL);

    const getOffsetY = () => {
      const v = getComputedStyle(document.documentElement).getPropertyValue('--header-offset').trim();
      if (v && !Number.isNaN(parseInt(v,10))) return parseInt(v,10);
      const hdr = document.querySelector('.site-header, header[role="banner"]');
      return hdr ? Math.round(hdr.getBoundingClientRect().height) : 120;
    };

    const activationY = () => Math.max(STICKY_TOP, getOffsetY());

    const endScroll = () => {
      scrolling = false;
      tween = null;
      if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
    };

    const scrollToPanel = (i, done) => {
      const target = panels[i];
      if (!target) return;
      const btn = btnById.get(target.id);
      currentIndex = i;
      if (btn) setActiveBtn(btn);
      if (tween) tween.kill();
      scrolling = true;
      tween = gsap.to(window, {
        duration: DURATION,
        scrollTo: { y: target, offsetY: activationY(), autoKill: true },
        ease: 'power2.out',
        overwrite: 'auto',
        onComplete: () => { gsap.delayedCall(0.06, () => { endScroll(); if (typeof done === 'function') done(); }); },
        onInterrupt: endScroll,
        onStop: endScroll
      });
      if (safetyTimer) clearTimeout(safetyTimer);
      safetyTimer = setTimeout(endScroll, Math.ceil((DURATION + 0.25) * 1000));
    };

    const stepBy = (dir) => {
      if (!canStep()) return false;
      const next = clamp(currentIndex + dir, 0, panels.length - 1);
      if (next === currentIndex) return false;
      lastIntent = performance.now();
      scrollToPanel(next);
      return true;
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const sel = btn.dataset.scrollTarget;
        if (!sel) return;
        const target = section.querySelector(sel);
        if (!target) return;
        const idx = panelIndex.get(target);
        if (idx == null) return;
        scrollToPanel(idx);
      });
    });

    const updateActiveFromScroll = () => {
      if (scrolling) return;
      const y = activationY();
      let best = currentIndex;
      for (let i = 0; i < panels.length; i++) {
        const r = panels[i].getBoundingClientRect();
        if (r.top <= y && r.bottom >= y) { best = i; break; }
      }
      if (best !== currentIndex) {
        currentIndex = best;
        const btn = btnById.get(panels[best].id);
        if (btn) setActiveBtn(btn);
      }
    };

    const measure = () => {
      navWrap.style.position = 'relative';
      navUl.style.position = 'absolute';
      navUl.style.top = '0px';
      navUl.style.left = '0px';
      navUl.style.width = '100%';
      navUl.style.transform = 'translate3d(0,0,0)';
      const prev = navUl.style.transition;
      navUl.style.transition = 'none';
      ulH = navUl.scrollHeight;
      colH = Math.max(panelsWrap.offsetHeight, ulH);
      navWrap.style.height = colH + 'px';
      wrapTop = navWrap.getBoundingClientRect().top + window.scrollY;
      maxOffset = Math.max(0, colH - ulH);
      void navUl.offsetHeight;
      navUl.style.transition = prev;
    };

    const updateSticky = () => {
      if (getComputedStyle(navWrap).display === 'none') return;
      const y = window.scrollY + STICKY_TOP - wrapTop;
      const offset = clamp(y, 0, maxOffset);
      navUl.style.transform = 'translate3d(0,' + offset + 'px,0)';
    };

    const inSection = (e) => {
      const r = section.getBoundingClientRect();
      const x = e.clientX, y = e.clientY;
      return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    };

    const onWheel = (e) => {
      if (!inSection(e)) return;
      const dir = e.deltaY > 0 ? 1 : -1;
      const stepped = stepBy(dir);
      if (stepped) e.preventDefault();
    };

    let tStartY = null;
    const onTouchStart = (e) => { hoverActive = true; tStartY = e.touches?.[0]?.clientY ?? null; };
    const onTouchMove = (e) => {
      if (tStartY == null) return;
      const y = e.touches?.[0]?.clientY ?? 0;
      const d = tStartY - y;
      if (Math.abs(d) < TOUCH_SNAP) return;
      const dir = d > 0 ? 1 : -1;
      const stepped = stepBy(dir);
      if (stepped) { e.preventDefault(); tStartY = null; }
    };
    const onEnter = () => { hoverActive = true; };
    const onLeave = (ev) => { if (ev.type === 'focusout' && section.contains(ev.relatedTarget)) return; hoverActive = false; };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        updateSticky();
        updateActiveFromScroll();
      });
    };

    const onResize = () => {
      measure();
      updateSticky();
      updateActiveFromScroll();
    };

    measure();
    updateSticky();
    updateActiveFromScroll();

    section.addEventListener('mouseenter', onEnter);
    section.addEventListener('mouseleave', onLeave);
    section.addEventListener('focusin', onEnter);
    section.addEventListener('focusout', onLeave);

    section.addEventListener('wheel', onWheel, { passive: false });
    section.addEventListener('touchstart', onTouchStart, { passive: true });
    section.addEventListener('touchmove', onTouchMove, { passive: false });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    const ro = new ResizeObserver(() => { onResize(); });
    ro.observe(navUl);
    ro.observe(panelsWrap);
  });
})();
